import { memo, MouseEventHandler } from 'react'

type DiagramLabelProps = {
    left: number,
    right: number,
    bottom: number,
    width: number,
    addressesAmount: number,
    onClick: MouseEventHandler,
    defaultLabel: string,
    labels: string[],
    fontWeight: number,
    fontSize: number,
    color: string
}
export const DiagramLabel = memo((
    {
        left,
        right,
        bottom,
        width,
        defaultLabel,
        labels,
        addressesAmount,
        onClick,
        fontWeight,
        fontSize,
        color
    }: DiagramLabelProps) => {

    const xPos = left < width / 2 ? right + 6 : left - 6
    const textAnchor = left < width / 2 ? "start" : "end"

    return (
        <g
            onClick={onClick}
        >
            {addressesAmount && !defaultLabel && <text
                x={xPos}
                y={bottom - 5}
                dy="0.35rem"
                lengthAdjust='length'
                textAnchor={textAnchor}
                fontSize={fontSize}
                fill={color}
            >
                {addressesAmount} {addressesAmount === 1 ? `address` : `addresses`}
            </text>}
            {<text
                x={xPos}
                y={bottom + 5}
                dy="0.35rem"
                textAnchor={textAnchor}
                fontSize={fontSize}
                fontWeight={fontWeight}
                fill={color}
            >
                {defaultLabel}
            </text>}
            {labels && labels.map((label, i) =>
                <text
                    key={label + '_' + i}
                    x={xPos}
                    y={bottom + ((i + 1) * 16)}
                    dy="0.35rem"
                    textAnchor={textAnchor}
                    fontSize={fontSize}
                    fill={color}
                >
                    {label}
                </text>)
            }
        </g>)
})
